import { Option } from "../components/common/forms/Interfaces";

export const emptyOption = {
  title: "",
  value: "",
} as Option;

export const YES_KEY = "1";
export const NO_KEY = "0";

export const YES = "Yes";
export const NO = "No";

export const MISTAKE_CLIENT = "client";
export const MISTAKE_CLIENT_CERT = "client_cert";
export const MISTAKE_CLIENT_EPI = "client_epi";
export const MISTAKE_KARSULA = "karsula";
export const MISTAKE_KARSULA_CERT = "karsula_sert";
export const MISTAKE_KARSULA_EPI = "karsula_epi";

export const DECLARANT_MISTAKES = [
  {
    title: "Client",
    value: MISTAKE_CLIENT,
  },
  {
    title: "Client (only cert)",
    value: MISTAKE_CLIENT_CERT,
  },
  {
    title: "Client (only epi)",
    value: MISTAKE_CLIENT_EPI,
  },
  {
    title: "Karsula",
    value: MISTAKE_KARSULA,
  },
  {
    title: "Karsula (only cert)",
    value: MISTAKE_KARSULA_CERT,
  },
  {
    title: "Karsula (only epi)",
    value: MISTAKE_KARSULA_EPI,
  },
] as Option[];

export const EXPOSED_VALUES = [
  {
    title: YES,
    value: YES_KEY,
  },
  {
    title: NO,
    value: NO_KEY,
  },
] as Option[];

export const GOTOWKA = "gotowka";
export const PRZELEW = "przelew";

export const PLATNOSC_VALUES = [
  {
    title: "",
    value: null,
  },
  {
    title: "Gotowka",
    value: GOTOWKA,
  },
  {
    title: "Przelew",
    value: PRZELEW,
  },
] as Option[];

export const CERT_STATUS_VALUES = {
  registered: "registered",
  resolution: "resolution",
  removed_from_control: "removed_from_control",
};

export const CERT_STATUS_TITLES = {
  [CERT_STATUS_VALUES.registered]: "Registered",
  [CERT_STATUS_VALUES.resolution]: "Resolution",
  [CERT_STATUS_VALUES.removed_from_control]: "Removed from control",
};

export const DECLARANT_CERT_STATUSES = [
  {
    title: CERT_STATUS_TITLES[CERT_STATUS_VALUES.registered],
    value: CERT_STATUS_VALUES.registered,
  },
  {
    title: CERT_STATUS_TITLES[CERT_STATUS_VALUES.resolution],
    value: CERT_STATUS_VALUES.resolution,
  },
  {
    title: CERT_STATUS_TITLES[CERT_STATUS_VALUES.removed_from_control],
    value: CERT_STATUS_VALUES.removed_from_control,
  },
] as Option[];
